import Button from 'ui/Button';
import Icon from 'ui/Icon';
import Tooltip from 'ui/Tooltip';

import { useSankeyFormContext } from '../../../../contexts/sankeyFormContext';
import { SankeyFlow } from '../../../../diagram/types';
import { useTeamContext } from '../../../../utils/team';
import { useSankeyFlowInteraction } from '../../../SankeyInteractionProvider/utils';
import { useHasDiagramMultipleFlows, useIsPeriferalFlow } from '../../utils';
import { removeFlow } from './utils';

interface Props {
  flow: SankeyFlow;
}

const FlowRemoveButton: React.FC<Props> = ({ flow }) => {
  const { form } = useSankeyFormContext();
  const { teamSettings } = useTeamContext();
  const { handleBlur } = useSankeyFlowInteraction(flow);

  const hasDiagramMultipleFlows = useHasDiagramMultipleFlows(form);
  const isPeriferalFlow = useIsPeriferalFlow(form, flow.id);

  return (
    <Tooltip
      content={
        !isPeriferalFlow
          ? 'Only periferal flows can be removed'
          : !hasDiagramMultipleFlows
            ? 'Removing this flow would make the diagram empty'
            : ''
      }
    >
      <Button
        variant="danger-ghost"
        fontWeight={400}
        onClick={() => {
          handleBlur();
          removeFlow(form, flow.id, teamSettings);
        }}
        disabled={!isPeriferalFlow || !hasDiagramMultipleFlows}
        size="xs"
      >
        <Icon icon="trash-can-regular" /> Remove
      </Button>
    </Tooltip>
  );
};

export default FlowRemoveButton;
